import {
  Button
  // DialogContentText
} from "@material-ui/core";
// import ActionDialog from "@saleor/components/ActionDialog";
import DeleteFilterTabDialog from "@saleor/components/DeleteFilterTabDialog";
import SaveFilterTabDialog, {
  SaveFilterTabDialogFormData
} from "@saleor/components/SaveFilterTabDialog";
import { PAGINATE_BY } from "@saleor/config";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
// import useNotifier from "@saleor/hooks/useNotifier";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
// import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import ShipmentListPage from "@saleor/shipment/components/ShipmentListPage/ShipmentListPage";
// import ShipmentListPage from "@saleor/shipment/components/ShipmentListPage";
// import { useShipmentBulkPublish } from "@saleor/shipment/mutations";
import { useShipmentListQuery } from "@saleor/shipment/queries";
import {
  shipmentListUrl,
  shipmentListUrlDialog,
  shipmentListUrlQueryParams,
  shipmentUrl
} from "@saleor/shipment/urls";
import { ListViews } from "@saleor/types";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import createFilterHandlers from "@saleor/utils/handlers/filterHandlers";
import createSortHandler from "@saleor/utils/handlers/sortHandler";
import { getSortParams } from "@saleor/utils/sort";
import React from "react";
import { FormattedMessage } from "react-intl";

import {
  areFiltersApplied,
  deleteFilterTab,
  getActiveFilters,
  getFilterTabs,
  getFilterVariables,
  saveFilterTab
} from "./filters";
// import { getSortQueryVariables } from "./sort";

interface ShipmentListProps {
  params: shipmentListUrlQueryParams;
}
const ShipmentList: React.FC<ShipmentListProps> = ({ params }) => {
  const tabs = getFilterTabs();

  // const notify = useNotifier();

  const handleTabDelete = () => {
    deleteFilterTab(currentTab);
    navigate(shipmentListUrl());
  };

  const handleTabSave = (data: SaveFilterTabDialogFormData) => {
    saveFilterTab(data.name, getActiveFilters(params));
    handleTabChange(tabs.length + 1);
  };

  const navigate = useNavigator();

  const paginate = usePaginator();

  const currentTab =
    params.activeTab === undefined
      ? areFiltersApplied(params)
        ? tabs.length + 1
        : 0
      : parseInt(params.activeTab, 0);

  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );

  const getFilterQueryParam = null;
  const [, resetFilters, handleSearchChange] = createFilterHandlers({
    cleanupFn: reset,
    createUrl: shipmentListUrl,
    getFilterQueryParam,
    navigate,
    params
  });

  const handleTabChange = (tab: number) => {
    reset();
    navigate(
      shipmentListUrl({
        activeTab: tab.toString(),
        ...getFilterTabs()[tab - 1].data
      })
    );
  };

  const [openModal, closeModal] = createDialogActionHandlers<
    shipmentListUrlDialog,
    shipmentListUrlQueryParams
  >(navigate, shipmentListUrl, params);

  const paginationState = createPaginationState(PAGINATE_BY, params);

  const queryVariables = React.useMemo(
    () => ({
      ...paginationState,
      filter: getFilterVariables(params)
      //   sort: getSortQueryVariables(params)
    }),
    [params]
  );

  // const [
  //     inseditBulkUpdate,
  //     shipmentBulkPublishOpts
  //   ] = useShipmentBulkPublish({
  //     onCompleted: data => {
  //       if (data.inseditBulkUpdate.errors.length === 0) {
  //         notify({
  //           status: "success",
  //           text: intl.formatMessage(commonMessages.savedChanges)
  //         });
  //         refetch();
  //         closeModal();
  //       }
  //     }
  // });

  const { data, loading } = useShipmentListQuery({
    variables: queryVariables
  });

  const { updateListSettings, settings } = useListSettings(
    ListViews.SALES_LIST
  );

  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    maybe(() => data.shipments.pageInfo),
    paginationState,
    params
  );

  const handleSort = createSortHandler(navigate, shipmentListUrl, params);

  return (
    <>
      <ShipmentListPage
        shipment={maybe(() => data.shipments.edges.map(edge => edge.node))}
        initialSearch={params.query || ""}
        onSearchChange={handleSearchChange}
        currentTab={currentTab}
        onAdd={null}
        onAll={resetFilters}
        onTabChange={handleTabChange}
        onTabDelete={() => openModal("delete-search")}
        onTabSave={() => openModal("save-search")}
        tabs={tabs.map(tab => tab.name)}
        disabled={loading}
        settings={settings}
        onNextPage={loadNextPage}
        onPreviousPage={loadPreviousPage}
        onSort={handleSort}
        onUpdateListSettings={updateListSettings}
        pageInfo={pageInfo}
        sort={getSortParams(params)}
        onRowClick={id => () => navigate(shipmentUrl(id))}
        toolbar={
          <>
            <Button
              color="primary"
              onClick={() =>
                openModal("unpublish", {
                  ids: listElements
                })
              }
            >
              <FormattedMessage
                defaultMessage="Unpublish"
                description="unpublish collections"
              />
            </Button>
            <Button
              color="primary"
              onClick={() =>
                openModal("publish", {
                  ids: listElements
                })
              }
            >
              <FormattedMessage
                defaultMessage="Publish"
                description="publish collections"
              />
            </Button>
          </>
        }
        isChecked={isSelected}
        selected={listElements.length}
        toggle={toggle}
        toggleAll={toggleAll}
      />
      {/* <ActionDialog
                open={
                params.action === "unpublish" && maybe(() => params.ids.length > 0)
                }
                onClose={closeModal}
                confirmButtonState={shipmentBulkPublishOpts.status}
                onConfirm={() =>
                inseditBulkUpdate({
                    variables: {
                    ids: params.ids,
                    published: false
                    }
                })
                }
                variant="default"
                title={intl.formatMessage({
                defaultMessage: "Unpublish collections",
                description: "dialog title"
                })}
            >
                <DialogContentText>
                    <FormattedMessage
                        defaultMessage="{counter,plural,one{Are you sure you want to unpublish this collection?} other{Are you sure you want to unpublish {displayQuantity} collections?}}"
                        values={{
                        counter: maybe(() => params.ids.length),
                        displayQuantity: <strong>{maybe(() => params.ids.length)}</strong>
                        }}
                    />
                </DialogContentText>
            </ActionDialog> */}
      {/* <ActionDialog
                open={params.action === "publish" && maybe(() => params.ids.length > 0)}
                onClose={closeModal}
                confirmButtonState={shipmentBulkPublishOpts.status}
                onConfirm={() =>
                inseditBulkUpdate({
                    variables: {
                    ids: params.ids,
                    published: true
                    }
                })
                }
                variant="default"
                    title={intl.formatMessage({
                    defaultMessage: "Publish collections",
                    description: "dialog title"
                })}
            >
                <DialogContentText>
                    <FormattedMessage
                        defaultMessage="{counter,plural,one{Are you sure you want to publish this collection?} other{Are you sure you want to publish {displayQuantity} collections?}}"
                        values={{
                            counter: maybe(() => params.ids.length),
                            displayQuantity: <strong>{maybe(() => params.ids.length)}</strong>
                        }}
                    />
                </DialogContentText>
            </ActionDialog> */}
      <SaveFilterTabDialog
        open={params.action === "save-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabSave}
      />
      <DeleteFilterTabDialog
        open={params.action === "delete-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabDelete}
        tabName={maybe(() => tabs[currentTab - 1].name, "...")}
      />
    </>
  );
};

export default ShipmentList;
